module.exports = __webpack_public_path__ + "static/media/16UNODC29.e87d4288.jpg";